import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MonLogService } from '@monsido/ng2/services/mon-log-service/mon-log.service';
import { CommonModule } from '@angular/common';

import { marked, RendererObject } from 'marked';
import DOMPurify from 'dompurify';

@Component({
    selector: 'mon-markdown-viewer',
    templateUrl: './markdown-viewer.component.html',
    imports: [CommonModule],
})
export class MarkdownViewerComponent implements OnChanges {
    @Input() monMarkdown = '';
    sanitizedDOMString = '';

    constructor (
        private monLogService: MonLogService,
    ) {}

    async ngOnChanges (changes: SimpleChanges): Promise<void> {
        if (changes.monMarkdown) {
            const domString = await this.markdownToHTML(this.monMarkdown);
            this.sanitizedDOMString = this.sanitizeDOMString(domString);
        }
    }

    private markdownToHTML (markdownString: string): string | Promise<string> {
        try {
            const renderer: RendererObject = {
                link (this, { href, title, text }): string {
                    return `<a target="_blank" rel="nofollow noopener" href="${href}" title="${title}">${text}</a>`;
                },
            };
            marked.use({ renderer });
            return marked.parse(markdownString);
        } catch (e) {
            this.monLogService.warn(
                `Unable to convert markdown to HTML string:\n
                 Error: ${e}\n
                 ${markdownString}`,
            );
            return '';
        }
    }

    private sanitizeDOMString (domString: string): string {
        if (!domString) {
            return '';
        }

        try {
            return DOMPurify.sanitize(domString, {
                USE_PROFILES: { html: true },
                ADD_ATTR: ['target'],
            });
        } catch (e) {
            this.monLogService.warn(
                `Unable to sanitize DOM string\n
                 Error: ${e}\n
                 ${domString}\n
                `,
            );
            return '';
        }
    }
}
